import React, { useEffect, useState, useReducer } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Grid,
  Checkbox,
  Select,
  TextField,
  MenuItem,
  Input,
  Chip,
  ListItemText,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography
} from "@material-ui/core";
import useStyles from "./CallOverVerification.css";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { CallOverVerificationState } from "../../../reducers/vendor/CallOverVerificationReducer";
import { CallOverVerificationService } from "../../../services/CallOverVerificationService";
import translation from "../../../i18n/i18.json";
import { RootState } from "../../../reducers";
import { useDispatch, useSelector } from "react-redux";
import AllActions from "../../../actions";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ApproveDialog from "../../../components/Vendor/Popup/Confirmation/ApproveDialog";
import RejectDialog from "../../../components/Vendor/Popup/Confirmation/RejectDialog";
import { ApprovalStatusData } from "../../../models/Approval/ApprovalStatusData";
import {
  AppApprovalPoints,
  NavigationPaths,
  RequestTypes,
} from "../../../constants/AppConstants";
import { useHistory, useLocation } from "react-router-dom";
import { VendorDetailService } from "../../../services/VendorDetailService";
import { CallOverBankDetails } from "../../../models/CallOverBankDetails";
import { BankDetails } from "../../../models/BankDetails";
import { UserLoginState } from "../../../reducers/LoginReducer";
import { Common } from "../../../utils/Common";

export default function CallOVerVerification(props: any) {

  class BankValidationResults {
    bankAccountNo: boolean;
    accountHolderName: boolean;
    bankName: boolean;
    bankBranch: boolean;
    swiftCode: boolean;
 
    constructor(bankAccountNo: boolean, accountHolderName: boolean, bankName: boolean, bankBranch: boolean, swiftCode: boolean) {
      this.bankAccountNo = bankAccountNo;
      this.accountHolderName = accountHolderName;
      this.bankName = bankName;
      this.bankBranch = bankBranch;
      this.swiftCode = swiftCode;
    }
  }

  interface ValidationResults {
    vendorName: boolean;
    emailAddress: boolean[];
    nameOfTheContactedPerson: boolean;
    designationOftheContactedPerson: boolean;
    bankDetails: Array<BankValidationResults>;
    contactName:boolean;
    contactNumber: boolean;
    callerVerifierDesignation: boolean;
    vendorCountry: boolean,
    vendorStreet : boolean,
    vendorPostalCode: boolean,
    vendorCity: boolean,
    vendorBR: boolean
  }

  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const requestId = props.location.state.requestId;

  const [dataToApprove, setDataToApprove] = useState<ApprovalStatusData>();
  const [openApprove, setOpenApprove] = useState(false);
  const [openReject, setOpenReject] = useState(false);
  const [callOverData, setCallOverData] = useState<CallOverVerificationState>();
  const [emailsValid, setEmailsValid] = useState(false);
  const [contactsValid, setContactsValid] = useState(false);
  const [bankDetailsValid, setBankDetailsValid] = useState(false);

  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [validationInitialState, setValidationInitialState] =
    useState<ValidationResults>({
      vendorName: false,
      emailAddress: [],
      nameOfTheContactedPerson: false,
      designationOftheContactedPerson: false,
      bankDetails: [],
      contactName: false,
      contactNumber: false,
      callerVerifierDesignation: false,
      vendorCountry: false,
      vendorStreet : false,
      vendorPostalCode: false,
      vendorCity: false,
      vendorBR: false
    });

    const allValid: boolean = validationInitialState.callerVerifierDesignation && validationInitialState.vendorName &&
    validationInitialState.designationOftheContactedPerson && validationInitialState.contactNumber &&
    validationInitialState.vendorBR &&
    validationInitialState.vendorStreet && validationInitialState.vendorPostalCode && validationInitialState.vendorCity && validationInitialState.vendorCountry &&
    emailsValid && ((callOverData && callOverData.bankDetails.length === 0) || bankDetailsValid) && contactsValid;
    
  const loggedUser : UserLoginState = JSON.parse(Common.getLoginUserData()!);
  
  const callOverInput: CallOverVerificationState = useSelector<
    RootState,
    CallOverVerificationState
  >((state) => state.callOverVerifications);

  useEffect(() => {
    dispatch(AllActions.callOverVerificationAction.resetVendorCallover());
    VendorDetailService.GetCallOverVerificationData(
      requestId,
      (result) => {
        setCallOverData(result);
        if (result.emailAddress) {
          dispatch(
            AllActions.callOverVerificationAction.addEmptyEmails(
              result.emailAddress.length
            )
          );
        }
        if (result.bankDetails) {
          dispatch(
            AllActions.callOverVerificationAction.addEmptyBankDetails(
              result.bankDetails.length
            )
          );
            let emptyBArray = new Array<BankValidationResults>();
            for(var i =0; i < result.bankDetails.length; i++){
              setBankDetailFields(result.bankDetails[i], emptyBArray);
            }
            validationInitialState.bankDetails = emptyBArray;
            setValidationInitialState(validationInitialState);
        }
      },
      (error) => {
        dispatch(AllActions.callOverVerificationAction.resetVendorCallover());
      }
    );
  }, []);


  const setBankDetailFields = (bank: CallOverBankDetails, emptyBArray: BankValidationResults[]) => {
    var validObj = new BankValidationResults(false, false, false, false, false);
    if (!bank.accountHolderName) {
      validObj.accountHolderName = true;
    }
    if (!bank.swiftCode) {
      validObj.swiftCode = true;
    }
    if (!bank.bankAccountNo) {
      validObj.bankAccountNo = true;
    }
    if (!bank.bankBranch) {
      validObj.bankBranch = true;
    }
    if (!bank.bankName) {
      validObj.bankName = true;
    }
    emptyBArray.push(validObj);
  }

  const generateInputHint = (value: string): string => {
    // let charLength = value != null ? value.length : 0;
    // let isStarBrek: boolean = false;
    // var result: string = "";
    // if (charLength < 5) {
    //   for (var x = 0; x < charLength; x++) {
    //     result = result + "*";
    //   }
    // } else {
    //   for (let index = 0; index < charLength; index++) {
    //     if (index % 3 === 0) {
    //       isStarBrek = true;
    //     }
    //     if (index % 6 === 0) {
    //       isStarBrek = false;
    //     }
    //     if (isStarBrek) {
    //       result = result + value.charAt(index);
    //     }
    //     else {
    //       result = result + "*";
    //     }
    //   }
    // }
    // return result;
    return value;
  };

  const validateBankField = (index: number, input: string, value: string) => {
    let isValid: boolean = false;
    if (callOverData !== undefined && callOverData["bankDetails"]) {
      let BankArr = callOverData["bankDetails"][index];
      let fieldval: any = BankArr[input as keyof CallOverBankDetails];
      if (!fieldval || (typeof fieldval == "number" && fieldval.toString() === value)) {
        isValid = true;
      } else if (!fieldval || (typeof fieldval == "string" && fieldval.toLowerCase().trim() === value.toLowerCase().trim())) {
        isValid = true;
      }
      switch (input) {
        case "bankAccountNo": {
          validationInitialState.bankDetails[index].bankAccountNo = isValid;
          break;
        }
        case "accountHolderName": {
          validationInitialState.bankDetails[index].accountHolderName = isValid;
          break;
        }
        case "bankName": {
          validationInitialState.bankDetails[index].bankName = isValid;
          break;
        }
        case "bankBranch": {
          validationInitialState.bankDetails[index].bankBranch = isValid;
          break;
        }
        case "swiftCode": {
          validationInitialState.bankDetails[index].swiftCode = isValid;
          break;
        }
      }
      setValidationInitialState(validationInitialState);
      if(callOverData.bankDetails.length > 0 && validationInitialState.bankDetails.length === callOverData!.bankDetails.length && validationInitialState.bankDetails.find((po) => {
             return !po.bankAccountNo || !po.accountHolderName || !po.bankName || !po.bankBranch || !po.swiftCode;
      }) != null){
        setBankDetailsValid(false);
      }else{
        setBankDetailsValid(true);
      }   
    }
  }
  const validateField = (input: string, value: string) => {
    let isValid: boolean = false;
    if (callOverData !== undefined && callOverData[input as keyof CallOverVerificationState]) {
      let fieldval: any = callOverData[input as keyof CallOverVerificationState];
      if (!fieldval || (typeof fieldval == "number" && fieldval.toString() === value)) {
        isValid = true;
      } else if (
        typeof fieldval == "string" &&
        fieldval.toLowerCase().trim() == value.toLowerCase().trim()
      ) {
        isValid = true;
      }
    }
    switch (input) {
      case "vendorName": {
        validationInitialState.vendorName = isValid;
        break;
      }
      case "nameOfTheContactedPerson": {
        validationInitialState.nameOfTheContactedPerson = isValid;
        break;
      }
      case "designationOftheContactedPerson": {
        validationInitialState.designationOftheContactedPerson = isValid;
        break;
      }
      case "vendorStreet": {
        validationInitialState.vendorStreet = isValid;
        break;
      }
      case "vendorPostalCode": {
        validationInitialState.vendorPostalCode = isValid;
        break;
      }
      case "vendorCity": {
        validationInitialState.vendorCity = isValid;
        break;
      }
      case "vendorCountry": {
        validationInitialState.vendorCountry = isValid;
        break;
      }
      case "vendorBR": {
        validationInitialState.vendorBR = isValid;
        break;
      }
    }
    setValidationInitialState(validationInitialState);
  };

  const validateVerifierDesignation = (value: string) => {
    if (value && value.trim()) {
      validationInitialState.callerVerifierDesignation = true;
    } else {
      validationInitialState.callerVerifierDesignation = false;
    }
    setValidationInitialState(validationInitialState);
  };

  const validateEmailAddress = (index: number, value: string) => {
    if (
      callOverData !== undefined &&
      callOverData.emailAddress[index].toLowerCase().trim() == value.toLowerCase().trim()
    ) {
      validationInitialState.emailAddress[index] = true;
    } else {
      validationInitialState.emailAddress[index] = false;
    }
    setValidationInitialState(validationInitialState);

    setEmailsValid(
      validationInitialState.emailAddress.length ===
      callOverData!.emailAddress.length &&
      validationInitialState.emailAddress.every((e) => {
        return e;
      })
    );
  };

  const validateContacts = (value: string) => {
    if (callOverData !== undefined) {
      let arr: string[] = [];
      callOverData.contactPersonNames.forEach(element => {
        if(element){
        arr.push(element.toLowerCase());
        }
      });
      if (arr.indexOf(value.toLowerCase()) > -1) {
        validationInitialState.contactName = true;
      } else {
        validationInitialState.contactName = false;
      }
    }else{
      validationInitialState.contactName = false;
    }
    setValidationInitialState(validationInitialState);
    setContactsValid(validationInitialState.contactName);
  };

  const validateContactNumbers = (value: string) => {
    if (callOverData !== undefined) {
      let arr: string[] = [];
      callOverData.contactNumbers.forEach(element => {
        if(element){
        arr.push(element.toLowerCase());
        }
      });
      if (arr.indexOf(value.toLowerCase()) > -1) {
        validationInitialState.contactNumber = true;
      } else {
        validationInitialState.contactNumber = false;
      }
    }else{
      validationInitialState.contactNumber = false;
    }
    setValidationInitialState(validationInitialState);
    //setContact(validationInitialState.contactNumber);
  };

  const handleEmailChange = (index: number) => (e: any) => {
    dispatch(
      AllActions.callOverVerificationAction.onValidateEmail(
        "emailAddress",
        index,
        e.target.value
      )
    );
    validateEmailAddress(index, e.target.value);
    forceUpdate();
  };

  const handleVerifierDesignationChange = (input: string) => (e: any) => {
    dispatch(
      AllActions.callOverVerificationAction.onValidateField(
        input,
        e.target.value as string[]
      )
    );
    validateVerifierDesignation(e.target.value);
    forceUpdate();
  };

  const handleContactsChange = (input: string) => (e: any) => {
    dispatch(
      AllActions.callOverVerificationAction.onValidateField(
        input,
        e.target.value as string[]
      )
    );
    validateContacts(e.target.value);
    forceUpdate();
  };

  const handleContactNumbersChange = (input: string) => (e: any) => {
    dispatch(
      AllActions.callOverVerificationAction.onValidateField(
        input,
        e.target.value as string[]
      )
    );
    validateContactNumbers(e.target.value);
    forceUpdate();
  };

  const handleChange = (input: string) => (e: any) => {
    dispatch(
      AllActions.callOverVerificationAction.onValidateField(
        input,
        e.target.value as string[]
      )
    );
    validateField(input, e.target.value);
  };

  const handleBankChange = (index: number, input: string) => (e: any) => {
    dispatch(
      AllActions.callOverVerificationAction.onValidateBankField(
        input,index,e.target.value as string
      )
    );
    validateBankField(index, input, e.target.value);
  }

  const onAproveRequestConfirm = (approvalLevelId: number) => {
    setOpenApprove(false);
    if (approvalLevelId === -1) {
      //remove the item from the list
      // removeItemVendorList(selectedItem!.requestId);
    } else {
      //setTimeout(() => {
      dispatch(AllActions.callOverVerificationAction.resetVendorCallover());
      history.push(NavigationPaths.Dashboard);
      //}, 3 * 1000);
    }
  };

  const onAproveRequestCancel = () => {
    setOpenApprove(false);
  };

  const onApproveClose = () => {
    setOpenApprove(false);
  };
  const onRejectRequestConfirm = (approvalLevelId: number) => {
    //send aprove request
    setOpenReject(false);
    if (approvalLevelId === -1) {
      //remove the item from the list
      //  removeItemVendorList(selectedItem!.requestId);
    } else {
      //update approvalLevelId
      //  updateVendorListApprovalLevelId(selectedItem!.requestId, approvalLevelId);
      //setTimeout(() => {
      dispatch(AllActions.callOverVerificationAction.resetVendorCallover());
      history.push(NavigationPaths.Dashboard);
      //}, 1 * 1000);
    }
  };

  const onRejectRequestCancel = () => {
    setOpenReject(false);
  };

  const onRejectClose = () => {
    setOpenReject(false);
  };

  const onApproveClick = () => {
    setDataToApprove({
      requestId: callOverData != null ? callOverData.requestId! : 0,
      companyCountryCode: '',
      approvalStatusId: 1,
      approvalLevelId: callOverData?.requestTypeId == RequestTypes.VendorCreate ? AppApprovalPoints.VCCallBack : AppApprovalPoints.AmendCallover,
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: false,
      isSendVerificationNotification: dataToApprove ? dataToApprove.isSendVerificationNotification : false,
      verifiedContactPersonName: callOverInput.contactName,
      requestComment: dataToApprove ? dataToApprove.requestComment : "",
      vcExtendedInputs: {
        purposeCode: "",
        accountingClark: "",
        accountingClarkEmail: "",
        instructionKey: "",
        sortKey: "",
        isIndividualVendor: false
      },
      verifierDesignation: callOverInput.callerVerifierDesignation,
      checkListItems: [],
      vendorTypeCode: callOverData ? callOverData.vendorTypeCode : "",
       isTemporaryApproval:false,
      temporaryApprovalNoOfDays:""
    });
    setOpenApprove(true);
  };

  const onRejectClick = () => {
    setDataToApprove({
      requestId: callOverData != null ? callOverData.requestId! : 0,
      companyCountryCode: '',
      approvalStatusId: 2,
      approvalLevelId: callOverData?.requestTypeId == RequestTypes.VendorCreate ? AppApprovalPoints.VCCallBack : AppApprovalPoints.AmendCallover,
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: false,
      isSendVerificationNotification: false,
      verifiedContactPersonName:"",
      requestComment: dataToApprove ? dataToApprove.requestComment : "",
      vcExtendedInputs: {
        purposeCode: "",
        accountingClark: "",
        accountingClarkEmail: "",
        instructionKey: "",
        sortKey: "",
        isIndividualVendor: false
      },
      verifierDesignation: callOverInput.callerVerifierDesignation,
      checkListItems: [],
      vendorTypeCode:callOverData ? callOverData.vendorTypeCode : "",
      isTemporaryApproval:false,
      temporaryApprovalNoOfDays:""
    });
    setOpenReject(true);
  };

  const onCannotVerifyClick = () => {
    setDataToApprove({
      requestId: callOverData != null ? callOverData.requestId! : 0,
      companyCountryCode: '',
      approvalStatusId: 2,
      approvalLevelId: callOverData?.requestTypeId == RequestTypes.VendorCreate ? AppApprovalPoints.VCCallBack : AppApprovalPoints.AmendCallover,
      reasonForRejection: "",
      isUrgentRequest: false,
      isCalloverCannotVerify: true,
      isSendVerificationNotification: false,
      verifiedContactPersonName:"",
      requestComment: dataToApprove ? dataToApprove.requestComment : "",
      vcExtendedInputs: {
        purposeCode: "",
        accountingClark: "",
        accountingClarkEmail: "",
        instructionKey: "",
        sortKey: "",
        isIndividualVendor: false
      },
      verifierDesignation: callOverInput.callerVerifierDesignation,
      checkListItems: [],
      vendorTypeCode:callOverData ? callOverData.vendorTypeCode : "",
      isTemporaryApproval:false,
      temporaryApprovalNoOfDays : ""
    });
    setOpenReject(true);
  };

  const onViewDetailClick = () => {
    window.open("/VendorDetail/" + requestId,"_blank");
  };

  return (
    <div>
      <div className={classes.contentOuterBG}>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12} className={classes.createHeader} >
          <span className={classes.createHeaderTxt}>
            {translation.callOverVerification_title}
          </span>
          <span className={classes.createHeaderLine}></span>
        </Grid>
        <Accordion style={{ width: "100%" }} className={classes.accwrapper} defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accHeader}>
            <Typography>CALLER VERIFIER</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid style={{ paddingBottom: "12px" }} container spacing={2} item xs={12} sm={12} md={12} lg={12}>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.callOverVerification_verifier_name}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <span className={classes.textWrap}>
                    {loggedUser.userName}
                  </span>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.callOverVerification_verifier_designation}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField 
                  id="callerVerifierDesignation"
                  value={callOverInput.callerVerifierDesignation} 
                  onChange={handleVerifierDesignationChange("callerVerifierDesignation")}
                  />
                  {!(callOverInput && callOverInput.callerVerifierDesignation) ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) :  (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  )}
                </Grid>
              </Grid>          
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Accordion style={{ width: "100%" }} className={classes.accwrapper} defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accHeader}>
            <Typography>VENDOR DETAIL</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid style={{ paddingBottom: "12px" }} container spacing={2} item xs={12} sm={12} md={12} lg={12}>
            <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.callOverVerification_Vendor_Type}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="vendorType"
                    InputProps={{readOnly: true}}
                    value={callOverData?.vendorTypeCode}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.callOverVerification_communication_method}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="communicationMethod"
                    InputProps={{readOnly: true}}
                    value={callOverData?.preferedCommMethod}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.callOverVerification_Vendor_Name}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="vendorName"
                    value={callOverInput.vendorName}
                    onChange={handleChange("vendorName")}
                  />
                  {callOverInput &&
                    callOverInput.vendorName != "" &&
                    !validationInitialState.vendorName ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.vendorName != "" &&
                    validationInitialState.vendorName ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}

                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.vendorName)}
                  </span>
              </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.callOverVerification_Contact}
                      </span>
                    </Grid>
                    <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="contactName"
                    value={callOverInput.contactName}
                    onChange={handleContactsChange("contactName")}
                  />
                  {callOverInput &&
                    callOverInput.contactName !== "" &&
                    !validationInitialState.contactName ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.contactName !== "" &&
                    validationInitialState.contactName ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}
                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.contactPersonNames.join(','))}
                  </span>
              </Grid> 
              <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.callOverVerification_Contact_Person_Designation}
                      </span>
                    </Grid>
                    <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="designationOftheContactedPerson"
                    value={callOverInput.designationOftheContactedPerson}
                    onChange={handleChange("designationOftheContactedPerson")}
                  />
                  {callOverInput &&
                    callOverInput.designationOftheContactedPerson != "" &&
                    !validationInitialState.designationOftheContactedPerson ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.designationOftheContactedPerson != "" &&
                    validationInitialState.designationOftheContactedPerson ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}
                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.designationOftheContactedPerson)}
                  </span>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.callOverVerification_Contact_Number}
                      </span>
                    </Grid>
                    <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="contactNumber"
                    value={callOverInput.contactNumber}
                    onChange={handleContactNumbersChange("contactNumber")}
                  />
                  {callOverInput &&
                    callOverInput.contactNumber != "" &&
                    !validationInitialState.contactNumber ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.contactNumber != "" &&
                    validationInitialState.contactNumber ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}
                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.contactNumbers.join(','))}
                  </span>              
              </Grid>              
              {callOverData &&
                callOverData.emailAddress &&
                callOverData.emailAddress.map((e, i) => (
                  <Grid item xs={12} sm={12} md={6} lg={4}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <span className={classes.createLbl}>
                        {translation.callOverVerification_Email}
                      </span>
                    </Grid>
                    {/* <select/> */}
                    <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                      <TextField
                        id={"Email_" + i}
                        value={callOverInput.emailAddress[i]}
                        onChange={handleEmailChange(i)}
                      />
                      {callOverInput &&
                        callOverInput.emailAddress.length > 0 &&
                        callOverInput.emailAddress[i] != null &&
                        callOverInput.emailAddress[i] != "" &&
                        !validationInitialState.emailAddress[i] ? (
                        <span className={classes.validationIconRed}>
                          <CancelIcon id={"btnErrorEmail_" + i}></CancelIcon>
                        </span>
                      ) : callOverInput &&
                        callOverInput.emailAddress.length > 0 &&
                        callOverInput.emailAddress[i] != null &&
                        callOverInput.emailAddress[i] != "" &&
                        validationInitialState.emailAddress[i] ? (
                        <span className={classes.validationIconGreen}>
                          <CheckCircleIcon></CheckCircleIcon>
                        </span>
                      ) : null}

                    </Grid>
                    <span className={classes.txtHint}>
                        {callOverData &&
                          generateInputHint(callOverData.emailAddress[i])}
                      </span>
                  </Grid>
                ))}
                <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span style={{ width: "100px" }} className={classes.createLbl}>
                    {translation.callOverVerification_Vendor_BR}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="vendorBR"
                    value={callOverInput.vendorBR}
                    onChange={handleChange("vendorBR")}
                  />
                  {callOverInput &&
                    callOverInput.vendorBR != "" &&
                    !validationInitialState.vendorBR ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.vendorBR != "" &&
                    validationInitialState.vendorBR ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}

                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.vendorBR)}
                  </span>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.callOverVerification_Vendor_Street}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="vendorStreet"
                    value={callOverInput.vendorStreet}
                    onChange={handleChange("vendorStreet")}
                  />
                  {callOverInput &&
                    callOverInput.vendorStreet != "" &&
                    !validationInitialState.vendorStreet ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.vendorStreet != "" &&
                    validationInitialState.vendorStreet ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}

                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.vendorStreet)}
                  </span>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                <span className={classes.createLbl}>
                    {translation.callOverVerification_Vendor_Postal_Code}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="vendorPostalCode"
                    value={callOverInput.vendorPostalCode}
                    onChange={handleChange("vendorPostalCode")}
                  />
                  {callOverInput &&
                    callOverInput.vendorPostalCode != "" &&
                    !validationInitialState.vendorPostalCode ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.vendorPostalCode != "" &&
                    validationInitialState.vendorPostalCode ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}

                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.vendorPostalCode)}
                  </span>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span style={{ width: "100px" }} className={classes.createLbl}>
                    {translation.callOverVerification_Vendor_City}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="vendorCity"
                    value={callOverInput.vendorCity}
                    onChange={handleChange("vendorCity")}
                  />
                  {callOverInput &&
                    callOverInput.vendorCity != "" &&
                    !validationInitialState.vendorCity ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.vendorCity != "" &&
                    validationInitialState.vendorCity ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}
                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.vendorCity)}
                  </span>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={4}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <span className={classes.createLbl}>
                    {translation.callOverVerification_Vendor_Country}
                  </span>
                </Grid>
                <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                  <TextField
                    id="vendorCountry"
                    value={callOverInput.vendorCountry}
                    onChange={handleChange("vendorCountry")}
                  />
                  {callOverInput &&
                    callOverInput.vendorCountry != "" &&
                    !validationInitialState.vendorCountry ? (
                    <span className={classes.validationIconRed}>
                      <CancelIcon></CancelIcon>
                    </span>
                  ) : callOverInput &&
                    callOverInput.vendorCountry != "" &&
                    validationInitialState.vendorCountry ? (
                    <span className={classes.validationIconGreen}>
                      <CheckCircleIcon></CheckCircleIcon>
                    </span>
                  ) : null}

                </Grid>
                <span className={classes.txtHint}>
                    {callOverData && generateInputHint(callOverData.vendorCountry)}
                  </span>
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
        <Grid container spacing={2} item xs={12} sm={12} md={12} lg={12}>
          {callOverData && callOverData.bankDetails.map((bank, index) => (
            <Accordion style={{ width: "100%" }} className={classes.accwrapper} defaultExpanded>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.accHeader}>
                <Typography>
                  BANK DETAIL - {index + 1}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div className={classes.bankDetailBody}>
                  {bank && bank.bankAccountNo && (
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.callOverVerification_Bank_AC_NO}
                        </span>
                      </Grid>
                      {/* <select/> */}
                      <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                        <TextField
                          id={"bankAccountNo" + index}
                          value={callOverInput.bankDetails.length > 0 ? callOverInput.bankDetails[index].bankAccountNo : ""}
                          onChange={handleBankChange(index, "bankAccountNo")}
                        />

                        {callOverInput.bankDetails.length > 0 && validationInitialState.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].bankAccountNo != "" &&
                          !validationInitialState.bankDetails[index].bankAccountNo ? (
                          <span className={classes.validationIconRed}>
                            <CancelIcon></CancelIcon>
                          </span>
                        ) : callOverInput.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].bankAccountNo != "" &&
                          validationInitialState.bankDetails[index].bankAccountNo ? (
                          <span className={classes.validationIconGreen}>
                            <CheckCircleIcon></CheckCircleIcon>
                          </span>
                        ) : null}
                        {/* <span className={classes.validationIconRed}>
            <CancelIcon></CancelIcon>
            </span> */}
                      </Grid>
                      <span className={classes.txtHint}>
                          {callOverData &&
                            generateInputHint(bank.bankAccountNo)}
                        </span>
                    </Grid>
                  )}
                  {bank && bank.accountHolderName && (
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.callOverVerification_AC_Holder_Name}
                        </span>
                      </Grid>
                      {/* <select/> */}
                      <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                        <TextField
                          id={"accountHolderName" + index}
                          value={callOverInput.bankDetails.length > 0 ? callOverInput.bankDetails[index].accountHolderName : ""}
                          onChange={handleBankChange(index, "accountHolderName")}
                        />

                        {callOverInput.bankDetails.length > 0 && validationInitialState.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].accountHolderName != "" &&
                          !validationInitialState.bankDetails[index].accountHolderName ? (
                          <span className={classes.validationIconRed}>
                            <CancelIcon></CancelIcon>
                          </span>
                        ) : callOverInput.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].accountHolderName != "" &&
                          validationInitialState.bankDetails[index].accountHolderName ? (
                          <span className={classes.validationIconGreen}>
                            <CheckCircleIcon></CheckCircleIcon>
                          </span>
                        ) : null}
                        {/* <span className={classes.validationIconRed}>
            <CancelIcon></CancelIcon>
            </span> */}

                      </Grid>
                      <span className={classes.txtHint}>
                          {callOverData &&
                            generateInputHint(bank.accountHolderName)}
                        </span>
                    </Grid>
                  )}
                 
                  {bank && bank.bankName && (
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.callOverVerification_Bank_Name}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                        <TextField
                          id="bankName"
                          value={callOverInput.bankDetails.length > 0 ? callOverInput.bankDetails[index].bankName: ""}
                          onChange={handleBankChange(index, "bankName")}
                        />

                        {callOverInput.bankDetails.length > 0 && validationInitialState.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].bankName != "" &&
                          !validationInitialState.bankDetails[index].bankName ? (
                          <span className={classes.validationIconRed}>
                            <CancelIcon></CancelIcon>
                          </span>
                        ) : callOverInput.bankDetails.length > 0 && validationInitialState.bankDetails.length > 0 &&
                        callOverInput.bankDetails[index].bankName != "" &&
                          validationInitialState.bankDetails[index].bankName ? (
                          <span className={classes.validationIconGreen}>
                            <CheckCircleIcon></CheckCircleIcon>
                          </span>
                        ) : null}
                        {/* <span className={classes.validationIconRed}>
            <CancelIcon></CancelIcon>
            </span> */}
  
                      </Grid>
                      <span className={classes.txtHint}>
                          {callOverData && generateInputHint(bank.bankName)}
                        </span>
                    </Grid>
                  )}
                  {bank && bank.bankBranch && (
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.callOverVerification_Bank_Branch}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                        <TextField
                          id="bankBranch"
                          value={callOverInput.bankDetails.length > 0 ? callOverInput.bankDetails[index].bankBranch : ""}
                          onChange={handleBankChange(index,"bankBranch")}
                        />
                        {callOverInput.bankDetails.length > 0 && validationInitialState.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].bankBranch != "" &&
                          !validationInitialState.bankDetails[index].bankBranch ? (
                          <span className={classes.validationIconRed}>
                            <CancelIcon></CancelIcon>
                          </span>
                        ) : callOverInput.bankDetails.length > 0 && validationInitialState.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].bankBranch != "" &&
                          validationInitialState.bankDetails[index].bankBranch ? (
                          <span className={classes.validationIconGreen}>
                            <CheckCircleIcon></CheckCircleIcon>
                          </span>
                        ) : null}
                        {/* <span className={classes.validationIconRed}>
            <CancelIcon></CancelIcon>
            </span>  */}

                      </Grid>
                      <span className={classes.txtHint}>
                          {bank && generateInputHint(bank.bankBranch)}
                        </span>
                    </Grid>
                  )}
                  {callOverData && bank.swiftCode && (
                    <Grid item xs={12} sm={12} md={6} lg={4}>
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <span className={classes.createLbl}>
                          {translation.callOverVerification_Swift_Code}
                        </span>
                      </Grid>
                      <Grid className={classes.inputWrapper} item xs={12} sm={12} md={11} lg={11} >
                        <TextField
                          id="swiftCode"
                          value={callOverInput.bankDetails.length > 0 ? callOverInput.bankDetails[index].swiftCode :""}
                          onChange={handleBankChange(index, "swiftCode")}
                        />
                        {callOverInput.bankDetails.length > 0 && validationInitialState.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].swiftCode != "" &&
                          !validationInitialState.bankDetails[index].swiftCode ? (
                          <span className={classes.validationIconRed}>
                            <CancelIcon></CancelIcon>
                          </span>
                        ) : callOverInput.bankDetails.length > 0 && validationInitialState.bankDetails.length > 0 &&
                          callOverInput.bankDetails[index].swiftCode != "" &&
                          validationInitialState.bankDetails[index].swiftCode ? (
                          <span className={classes.validationIconGreen}>
                            <CheckCircleIcon></CheckCircleIcon>
                          </span>
                        ) : null}
                        {/* <span className={classes.validationIconRed}>
            <CancelIcon></CancelIcon>
            </span>  */}

                      </Grid>
                      <span className={classes.txtHint}>
                          {callOverData && generateInputHint(bank.swiftCode)}
                        </span>
                    </Grid>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
          )
          )}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <div className={classes.BtnArea}>
              {!allValid ? (
                <div className={classes.redBtnWrapper}>
                  <Button onClick={onRejectClick}>
                    {translation.callOverVerification_Btn_Txt_Reject}
                  </Button>
                </div>
              ) : (
                <div className={classes.BtnGreenWrapper}>
                  <Button onClick={onApproveClick}>
                    <CheckCircleIcon></CheckCircleIcon>
                    {translation.callOverVerification_Btn_Txt_Approve}
                  </Button>
                </div>
              )}
              <div className={classes.BtnBlackWrapper}>
                <Button onClick={onCannotVerifyClick}>
                  {translation.callOverVerification_Btn_Txt_cannotverify}
                </Button>
              </div>
              <div className={classes.BtnBlueWrapper}>
                <Button onClick={onViewDetailClick}>
                  {translation.callOverVerification_btn_view_detail}
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>


      <ApproveDialog
        dataToApprove={dataToApprove!}
        setDataToApprove={setDataToApprove}
        open={openApprove}
        title={translation.dashboard_approve_title}
        message={translation.dashboard_approve_message}
        btnOnetext={translation.dashboard_approve_yesbtn}
        btnTwotext={translation.dashboard_reject_nobtn}
        onApproveConfirm={onAproveRequestConfirm}
        onApproveCancel={onAproveRequestCancel}
        handleClose={onApproveClose}
      ></ApproveDialog>
      <RejectDialog
        dataToReject={dataToApprove!}
        open={openReject}
        title={translation.dashboard_reject_title}
        message={translation.dashboard_reject_message}
        btnOnetext={translation.dashboard_reject_yesbtn}
        btnTwotext={translation.dashboard_reject_nobtn}
        onRejectConfirm={onRejectRequestConfirm}
        onRejectCancel={onRejectRequestCancel}
        handleClose={onRejectClose}
      ></RejectDialog>
    </div>
  );


}
